<template>
    <div class="invoice request-block">

        <div class="row">
            <div class="col-xs-6">
                <div class="request-header">
                    Заявка от {{request.date}}
                </div>
            </div>
            <div v-if="!from" class="col-xs-6">
                <div class="text-right">
                    <button @click="repeatRequest" :disabled="isDisabled" class="request-repeat-btn btn buyings___btn">Повторить заявку</button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 table-responsive">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th><input type="checkbox" v-model="selectAll"></th>
                        <th>№ Закупки</th>
                        <th>Тип Закупки</th>
                        <th>Товар</th>
                        <th>Дата подведения итогов</th>
                        <th>Цена</th>
                        <th class="text-center">Количество</th>
                        <th>Сумма</th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="item in request.items">
                        <td><label class="form-checkbox">
                            <input type="checkbox" :value="item" v-model="selected">
                            <i class="form-icon"></i>
                        </label></td>
                        <td><a :href="'/buyer/buying?id=' + item.buying_id + '&type=' + item.buying_type">№
                            {{item.buying_id}}</a></td>
                        <td>{{item.buying_type_name}}</td>
                        <td><a :href="'/catalog/default/prototype-view?cat=' + item.category_id">{{item.item_name}}</a>
                        </td>
                        <td>{{item.offer_date}}</td>
                        <td>{{item.price | pricePrecision}} руб.</td>
                        <td class="number-counter">
                            <div class="number-counter__minus" @click="item.count--">-</div>
                            <input type="text" class="number-counter__field" v-model="item.count">
                            <div class="number-counter__plus" @click="item.count++">+</div>
<!--                            {{item.count}}-->
                        </td>
                        <td>{{item.price_sum | pricePrecision}} руб.</td>
                    </tr>
                    </tbody>

                </table>
            </div>
        </div>

        <div class="row request-info">
            <div class="col-sm-4">
                Начальная общая стоимость: <strong>{{request.start_sum | pricePrecision}} руб.</strong>
            </div>
            <div class="col-sm-4">
                Процент снижения: <strong>{{request.percent_reduction}} %</strong>
            </div>
            <div class="col-sm-4">
                Текущая общая стоимость: <strong>{{request.current_sum | pricePrecision}} руб.</strong>
            </div>
        </div>

    </div>
</template>

<script>
    const COMPONENT_NAME = 'request-items-component';

    import BuyingService from "../services/BuyingService";

    export default {
        name: COMPONENT_NAME,
        props: {
            request: Object,
            from: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                selected: [],
                disabled: false,
            }
        },
        mounted() {
            this.checkAll();
        },
        computed: {
            isDisabled() {
                if (this.selected.length === 0) {
                    return this.disabled = true;
                } else {
                    return this.disabled = false;
                }
            },
            selectAll: {
                get: function () {
                    return this.request.items ? this.selected.length === Object.keys(this.request.items).length : false;
                },
                set: function (value) {
                    var selected = [];
                    if (value) {
                        $.each(this.request.items, function (key, item) {
                            selected.push(item);
                        })
                    }
                    this.selected = selected;
                }
            },
        },
        methods: {
            checkAll() {
                var selected = [];

                if (this.request.items) {
                    $.each(this.request.items, function (key, item) {
                        selected.push(item);
                    })
                }
                this.selected = selected;
            },
            async repeatRequest() {
                if (confirm('Товары, добавленные ранее в корзину, будут из нее удалены. Продолжить?')) {
                    if (this.selected) {
                        return console.log(this.selected);
                        let response = await BuyingService.repeatRequestAsBuying(this.selected);
                        let ref = this;

                        let $message, $text, $href, $type;
                        if (response.success) {
                            await this.$parent.getRequests();
                            this.createDOM(
                                $message = 'Закупка на выбраные товары была опубликована! Перейти в ',
                                $text = ' "Мои закупки"',
                                $href = '/buyer/',
                                $type = 'success'
                            );
                            if (Object.keys(response.errors).length !== 0) {
                                $.each(response.errors, function (key, error) {
                                    ref.createDOM(
                                        $message = 'Характеристики данных товаров не соответствуют представленым в каталоге:',
                                        $text = key + ' ' + error,
                                        $href = '/catalog/default',
                                        $type = 'error'
                                    )
                                });
                            }
                        }
                    }
                }
            },
            async createDOM($message, $text, $href, $type) {
                let text = this.$createElement('span', $message, {
                    children: href
                });

                let href = this.$createElement('a', {
                    domProps: {
                        innerHTML: $text,
                        href: $href
                    },
                });

                let message = this.$createElement('div', [
                    text, href
                ]);

                this.$notify({message: message, type: $type});
            },
        },
        filters: {
            pricePrecision: function (value) {
                if (!value) value = '';
                value = Number(value);
                value = value.toFixed(2);
                return value;
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/helpers/helpers';

    .request-block {
        position: relative;
        background: #ffffff;
        margin: 8px;
        padding-bottom: 30px;
        padding-left: 15px;
        padding-right: 15px;
        box-shadow: 0 0 5px rgba(122, 122, 122, 0.5);
    }

    .request-header {
        padding-bottom: 15px;
        padding-top: 15px;
        border-bottom: 1px solid #eeeeee;
        font-size: 28px;
        font-weight: 500;
    }

    .request-repeat-btn {
        margin: 15px;
        color: $buyer-color;
        border: 1px solid $buyer-color;
        background-color: $light-color;
        height: 40px;
        padding-top: 10px;
        padding-bottom: 10px;
        &:hover {
            background-color: $buyer-color;
            color: $light-color;
        }
    }

    .request-info {
        padding-top: 30px;
        border-top: 1px solid #eeeeee;
        text-align: center;
    }

    .number-counter {
        display: flex;
        max-width: 110px;

        &__field {
            width: 100%;
            height: 35px;
            border: 1px solid #c9ced1;
            border-radius: 0;
            text-align: center;
            color: #3f464e;
            font-size: 14px;
            font-weight: 400;
        }

        &__plus, &__minus {
            width: 40px;
            height: 36px;
            text-align: center;
            line-height: 35px;
            font-weight: 500;
            font-size: 20px;
            border: 1px solid #c9ced1;
        }

        &__plus:hover, &__minus:hover {
            cursor: pointer;
            -webkit-transition: background 0.35s ease;
            transition: background 0.35s ease;
        }
    }

</style>